import React from 'react';
import { observer } from "mobx-react-lite";
import ModalPopup from "../../components/modal";
import Button from "../../components/buttons";
import useToggleState from "components/hooks/useToggleState";
import modalStore from "./modalStore";

const ModalComponent: React.FC = () => {
    const modalState = useToggleState({});
    const [store] = React.useState(modalStore)

    const handleOk = () => {
        store.setShow(false);
        store.callback && store.callback(true);
    };
    const handleCancel = () => {
        store.setShow(false);
        store.callback && store.callback(false);
    };
    const handleClose = () => {
        if (store.confirm) {
            handleCancel();
        } else {
            handleOk();
        }
    }

    React.useEffect(() => {
        modalState.setShowing(store.show);
    }, [store.show])

    // you can replace the divs with your own modal component
    return (
        <>
        {store.show &&
            <ModalPopup
                open={modalState.isShowing}
                title={""}
                size="alert"
                onClose={handleClose}
            >
                <div className="modal-con">
                    <p className="msg">
                        {store.message}
                    </p>
                </div>
                <div className="modal-bottom">
                    {store.confirm && <Button color='gray-o' size="md" onClick={handleCancel}>취소</Button>}
                    <Button color='pri' size="md" onClick={handleOk}>확인</Button>

                </div>
            </ModalPopup>
        }
        </>
    )
};

export default observer(ModalComponent);